import spicePowdersImg from "@/lib/images/Spice Powders.png";
import wholeSpicesImg from "@/lib/images/Whole Spices.png";
import herbsImg from "@/lib/images/Herbs & Leaves.png";
import seasoningsImg from "@/lib/images/Seasonings & Blends.png";
import saltsImg from "@/lib/images/Salts.png";
import oilsImg from "@/lib/images/Oils & Extracts.png";
import ayurvedicImg from "@/lib/images/Ayurvedic & Herbal.png";
import pulsesImg from "@/lib/images/Pulses.png";

// Static data for Desi Masala Hub

export const BRAND = {
  name: "Desi Masala Hub",
  parent: "Kirti Trading",
  tagline: "Premium Indian Spices Wholesale Supplier & Exporter",
  phone: "+91-9220230231",
  whatsapp: "+91-9220230231",
  email: "info@desimasalahub.com",
  address: "428 Katra Maidgrn, Khari Baoli, Old Delhi, India - 110006",
  mapEmbed: "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3501.9485624987!2d77.21275!3d28.6562!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x390cfd5b347eb62d%3A0x37205b715389640!2sKhari%20Baoli!5e0!3m2!1sen!2sin!4v1700000000000",
  social: {
    facebook: "#",
    instagram: "#",
    linkedin: "#",
    twitter: "#",
  },
};

export const CATEGORIES = [
  {
    slug: "whole-spices",
    name: "Whole Spices",
    blurb: "Hand-picked whole spices, sun-dried and stone-cleaned for unmatched aroma and shelf life.",
    image: wholeSpicesImg,
    products: [
      "Ajwain / Carom Seeds", "Star Anise", "Coriander Seeds", "Small Cardamom", "Large Cardamom",
      "Black Cumin", "White Cumin", "Black Pepper", "White Pepper", "Cloves",
      "Fennel Seeds", "Fenugreek Seeds", "Mustard Seeds", "Poppy Seeds", "Sesame Seeds",
      "Bay Leaf", "Nutmeg", "Mace", "Cubeb", "Dry Ginger", "Tamarind"
    ],
    seo: ["Wholesale Whole Spices", "Premium Indian Spices", "Bulk Spice Supplier India"],
  },
  {
    slug: "spice-powders",
    name: "Spice Powders",
    blurb: "Stone-ground spice powders milled in temperature-controlled facilities to lock in essential oils.",
    image: spicePowdersImg,
    products: [
      "Turmeric Powder", "Red Chilli Powder", "Coriander Powder", "Garlic Powder", "Onion Powder",
      "Mango Powder (Amchur)", "Wild Turmeric Powder", "Kachri Powder", "Pumpkin Powder"
    ],
    seo: ["Turmeric Powder", "Red Chilli Powder Supplier", "Wholesale Spice Powder Exporter"],
  },
  {
    slug: "herbs",
    name: "Herbs & Leaves",
    blurb: "Air-dried culinary and medicinal herbs preserving colour, aroma and active compounds.",
    image: herbsImg,
    products: ["Basil", "Curry Leaves", "Mint", "Fenugreek Leaves", "Neem Leaves", "Rosemary", "Thyme", "Oregano"],
    seo: ["Wholesale Herbs Supplier", "Indian Culinary Herbs", "Dried Herbs Exporter"],
  },
  {
    slug: "seasonings",
    name: "Seasonings & Blends",
    blurb: "Signature blends and bespoke private-label seasonings crafted to your formulation.",
    image: seasoningsImg,
    products: ["Peri Peri Seasoning", "Peri Peri Spice Mix", "Italian Seasoning", "Custom Spice Blends"],
    seo: ["Seasoning Manufacturer", "Italian Seasoning Supplier", "Peri Peri Spice Exporter"],
  },
  {
    slug: "salts",
    name: "Salts",
    blurb: "Mineral-rich Himalayan and Indian salts ideal for culinary, industrial and wellness uses.",
    image: saltsImg,
    products: ["Black Salt", "Rock Salt", "Salt"],
    seo: ["Black Salt Supplier", "Rock Salt Exporter", "Bulk Salt Supplier"],
  },
  {
    slug: "oils-and-extracts",
    name: "Oils & Extracts",
    blurb: "Cold-pressed and steam-distilled oils — culinary, cosmetic and pharmaceutical grade.",
    image: oilsImg,
    products: ["Castor Oil", "Clove Oil", "Eucalyptus Oil", "Soya Refined Oil", "Menthol"],
    seo: ["Essential Oil Supplier", , "Industrial Oil Exporter"],
  },
  {
    slug: "ayurvedic-products",
    name: "Ayurvedic & Herbal",
    blurb: "Authentic ayurvedic raw materials sourced from traditional growers across India.",
    image: ayurvedicImg,
    products: ["Amla", "Harad", "Karpoor", "Karpoor Kachri", "Galingale", "Dandasa", "Pipal", "Fitkari", "Suhaga", "Godanti"],
    seo: ["Ayurvedic Raw Materials", "Herbal Product Supplier", "Natural Ingredients Exporter"],
  },
  {
    slug: "pulses",
    name: "Pulses",
    blurb: "Cleaned, polished and graded pulses ready for retail packaging or industrial use.",
    image: pulsesImg,
    products: ["Dal Arhar", "Dal Chana"],
    seo: ["Pulse Supplier India", "Wholesale Dal Supplier"],
  },
];

export const FEATURED_PRODUCTS = [
  { name: "Turmeric Powder", slug: "turmeric-powder-supplier-india", image: "https://images.pexels.com/photos/4198812/pexels-photo-4198812.jpeg", note: "Curcumin-rich, lab-tested" },
  { name: "Red Chilli Powder", slug: "red-chilli-powder", image: "https://images.unsplash.com/photo-1624351251625-cf02b018223c", note: "Vibrant colour, controlled heat" },
  { name: "Black Pepper", slug: "black-pepper-exporter", image: "https://images.unsplash.com/photo-1641661548431-87172338d58c", note: "Malabar & Tellicherry grades" },
  { name: "Coriander Seeds", slug: "coriander-seeds-bulk-supplier", image: "https://images.pexels.com/photos/4198015/pexels-photo-4198015.jpeg", note: "Eagle & split varieties" },
  { name: "Cardamom", slug: "cardamom-wholesale-supplier", image: "https://images.pexels.com/photos/13302550/pexels-photo-13302550.jpeg", note: "8mm bold green pods" },
  { name: "Cloves", slug: "cloves-supplier", image: "https://images.pexels.com/photos/5945755/pexels-photo-5945755.jpeg", note: "Hand-picked, high oil" },
  { name: "Fennel Seeds", slug: "fennel-seeds-supplier", image: "https://images.pexels.com/photos/4198941/pexels-photo-4198941.jpeg", note: "Lucknowi & Europe grade" },
  { name: "Bay Leaf", slug: "bay-leaf-supplier", image: "https://images.pexels.com/photos/4198023/pexels-photo-4198023.jpeg", note: "Whole, semi-broken" },
  { name: "Nutmeg", slug: "nutmeg-supplier", image: "https://images.pexels.com/photos/5945914/pexels-photo-5945914.jpeg", note: "Shelled, sound" },
  { name: "Ajwain", slug: "ajwain-supplier", image: "https://images.pexels.com/photos/4198021/pexels-photo-4198021.jpeg", note: "Machine-cleaned, 99% pure" },
];

export const WHY_CHOOSE_US = [
  { icon: "Sprout", title: "Farm Fresh Sourcing", body: "Direct procurement from trusted farms across India." },
  { icon: "BadgeCheck", title: "Quality Tested", body: "Lab-tested batches with strict QC at every stage." },
  { icon: "Boxes", title: "Bulk Supply Capacity", body: "Large-volume orders fulfilled with reliability." },
  { icon: "Package", title: "Custom Packaging", body: "Private label & retail packing solutions." },
  { icon: "Tag", title: "Competitive Pricing", body: "Best wholesale rates with transparent terms." },
  { icon: "Ship", title: "Export Ready", body: "Phytosanitary, FSSAI & international standards." },
  { icon: "Truck", title: "Timely Delivery", body: "Pan-India logistics & global freight partners." },
  { icon: "Headphones", title: "B2B Support", body: "Dedicated account managers for every client." },
];

export const INDUSTRIES = [
  "Food Processing Companies", "Restaurants", "Hotels", "Catering Businesses",
  "Retail Chains", "FMCG Brands", "Spice Traders", "Export Houses", "Grocery Stores",
];

export const COUNTRIES = [
  { name: "USA", code: "US" },
  { name: "Canada", code: "CA" },
  { name: "United Kingdom", code: "GB" },
  { name: "Australia", code: "AU" },
  { name: "UAE", code: "AE" },
  { name: "Europe", code: "EU" },
  { name: "Africa", code: "AF" },
];

export const TESTIMONIALS = [
  { name: "Rajiv Mehra", role: "Owner, Spice Route Restaurant", body: "Desi Masala Hub has been our trusted supplier for three years. The consistency in colour, aroma and quality is what keeps our kitchen running. Their bulk turmeric and chilli powders are simply unmatched." },
  { name: "Anita Krishnan", role: "Procurement Head, FreshBite Foods", body: "Their export-ready packaging and on-time shipments helped us scale to four international markets. The team is responsive and accommodates our private-label requirements beautifully." },
  { name: "James Whitaker", role: "Importer, London Spice Co.", body: "Documentation, certifications, container loading — everything was handled professionally. The Malabar pepper batch we received was exceptional. A reliable Indian partner." },
  { name: "Priya Shah", role: "Director, FMCG Brand", body: "We've audited their facility twice. Hygiene standards and traceability are excellent. Their custom seasoning blend formulated for our product line is now a bestseller." },
];

export const FAQ = [
  { q: "Do you provide wholesale pricing?", a: "Yes. All our products are priced on a bulk wholesale basis. Pricing is shared on request, after we understand your product, grade, volume and destination requirements." },
  { q: "What is your MOQ (Minimum Order Quantity)?", a: "MOQs vary by product. For most spices and powders, MOQ starts at 100 kg domestic and 500 kg / 1 MT for export. We can confirm exact MOQ once you share your inquiry." },
  { q: "Do you export internationally?", a: "Yes. We export to USA, Canada, UK, Australia, UAE, Europe and Africa with full documentation — phytosanitary, certificate of origin, FSSAI, and bespoke export packaging." },
  { q: "Can you provide custom packaging?", a: "Absolutely. We offer private-label, retail pouches, bulk PP/HDPE bags, and food-grade cartons. Share your design or brief and our team will prepare samples." },
  { q: "How can I request a quotation?", a: "Fill the Request Quote form on this page, message us on WhatsApp, or email us. We respond to all B2B inquiries within 24 business hours." },
  { q: "How long does delivery take?", a: "Domestic orders within India are dispatched in 3–7 days. Export orders typically ship 14–21 days after order confirmation, depending on documentation and packaging." },
  { q: "Are products quality tested?", a: "Every batch undergoes moisture, ash, oil-content and microbial testing in accredited labs. Certificates of Analysis (COA) are provided with every shipment." },
];

export const BLOG_POSTS = [
  {
    slug: "top-indian-spices-used-worldwide",
    title: "Top Indian Spices Used Worldwide",
    excerpt: "From turmeric to cardamom, discover the Indian spices that flavour the world's kitchens and shape global cuisines.",
    image: "https://images.pexels.com/photos/15318488/pexels-photo-15318488.jpeg",
    date: "Nov 12, 2025",
    read: "6 min read",
  },
  {
    slug: "benefits-of-turmeric-powder",
    title: "Benefits of Turmeric Powder",
    excerpt: "Beyond its golden colour, turmeric offers anti-inflammatory, antioxidant and culinary benefits that make it indispensable.",
    image: "https://images.pexels.com/photos/4198812/pexels-photo-4198812.jpeg",
    date: "Nov 03, 2025",
    read: "5 min read",
  },
  {
    slug: "how-to-choose-export-quality-spices",
    title: "How to Choose Export Quality Spices",
    excerpt: "Moisture, ASTA colour, oil content and certifications — a buyer's checklist to source spices that pass international tests.",
    image: "https://images.unsplash.com/photo-1777483997311-f882ae033e7b",
    date: "Oct 21, 2025",
    read: "8 min read",
  },
  {
    slug: "indian-spice-export-market-trends",
    title: "Indian Spice Export Market Trends",
    excerpt: "Volumes, top destinations and the trends shaping India's spice exports in 2025 and beyond.",
    image: "https://images.pexels.com/photos/262353/pexels-photo-262353.jpeg",
    date: "Oct 09, 2025",
    read: "7 min read",
  },
  {
    slug: "wholesale-spice-buying-guide",
    title: "Wholesale Spice Buying Guide",
    excerpt: "A practical guide for restaurants, retailers and FMCG brands to negotiate, evaluate and partner with the right supplier.",
    image: "https://images.pexels.com/photos/29672336/pexels-photo-29672336.jpeg",
    date: "Sep 27, 2025",
    read: "9 min read",
  },
];
